import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, waLink } from "@/lib/api";
import { ArrowRight, MessageCircle } from "lucide-react";

export default function Tours() {
  const [tours, setTours] = useState([]);
  useEffect(() => { api.get("/tours").then(r => setTours(r.data)).catch(() => {}); }, []);

  return (
    <div className="max-w-[1360px] mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
      <p className="text-xs uppercase tracking-[0.25em] font-bold text-turaco mb-3">Tururi și bilete</p>
      <h1 className="font-serif text-4xl lg:text-6xl text-forest-900 tracking-tight max-w-3xl">Alege ziua în care vrei să întâlnești animalele Habitatului</h1>
      <p className="mt-4 text-muted max-w-2xl">Un tur durează aproximativ 60 de minute. Tariful: 40 RON / persoană (adulți și copii peste 3 ani). Gratuit pentru copiii 0–3 ani și copiii cu dizabilități.</p>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {tours.length === 0 && (
          <div className="col-span-full bg-cream-50 rounded-3xl p-8 text-center">
            <p className="text-muted mb-4">Momentan nu sunt tururi publicate.</p>
            <a href={waLink()} target="_blank" rel="noreferrer" className="inline-flex bg-[#25D366] text-white rounded-full px-6 py-3 font-semibold gap-2 items-center">
              <MessageCircle className="w-4 h-4" /> Contactează-ne pe WhatsApp
            </a>
          </div>
        )}
        {tours.map(t => {
          const full = t.seats_available === 0 || t.status === "full";
          return (
            <div key={t.id} data-testid={`tours-page-tour-${t.id}`} className="bg-cream-50 rounded-3xl p-6 border border-forest-900/5">
              <div className="flex justify-between items-start mb-3">
                <div>
                  <div className="text-xs uppercase tracking-wider font-bold text-turaco">Tur ghidat</div>
                  <div className="font-serif text-2xl text-forest-900 mt-1">{new Date(t.date).toLocaleDateString('ro-RO', {weekday: 'long', day: 'numeric', month: 'long'})}</div>
                  <div className="text-forest-800 font-semibold">{t.start_time} · {t.duration_minutes} min</div>
                </div>
                {full ? <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded-full font-semibold">Complet</span> :
                  t.seats_available <= 3 && <span className="bg-tucan/10 text-tucan text-xs px-2 py-1 rounded-full font-semibold">Ultimele {t.seats_available}</span>}
              </div>
              <p className="text-sm text-muted mt-3">{t.description_short}</p>
              <div className="mt-4 flex items-baseline justify-between">
                <div className="text-forest-900 font-semibold text-lg">{t.price_adult} RON <span className="text-xs text-muted font-normal">/ pers.</span></div>
                <div className="text-xs text-muted">{t.seats_available} locuri</div>
              </div>
              {full ? (
                <a href={waLink(`Bună! Turul din ${t.date} ${t.start_time} este complet. Vă rog adăugați-mă pe lista de așteptare.`)} target="_blank" rel="noreferrer" className="mt-4 w-full bg-forest-900 text-cream-50 rounded-full py-3 font-semibold flex items-center justify-center gap-2">
                  <MessageCircle className="w-4 h-4" /> Lista de așteptare
                </a>
              ) : (
                <Link to={`/rezervare?tour=${t.id}`} data-testid={`tours-book-${t.id}`} className="mt-4 w-full bg-tucan text-white rounded-full py-3 font-semibold flex items-center justify-center gap-2">
                  Rezervă <ArrowRight className="w-4 h-4" />
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
